const requiredAppConfig = require("./index");

/**
 * Take the list of configuration parameters from the index of this submodule,,
 * read them from `window`,
 * and export them as an object.
 */
module.exports = requiredAppConfig.reduce((prev, curr) => {
  // In Jest, window.bundleConfiguration is faked onto JSDOM in jest.setup.js.
  // In WDS, window.bundleConfiguration is added to HTMLWebpackPlugin's generated output.
  // In Express, window.bundleConfiguration is added to SSR-ed HTML by our custom templater.
  if (
    typeof bundleConfiguration !== "undefined" &&
    //eslint-disable-next-line no-undef
    curr in bundleConfiguration
  ) {
    return {
      ...prev,
      //eslint-disable-next-line no-undef
      [curr]: bundleConfiguration[curr],
    };
  } else {
    throw new Error(`${curr} was not provided to the webpack bundle.`);
  }
}, {});
